export default __webpack_public_path__ + "6121839d6af184cac694a06f736f9b93.webp";